
export const MY_PROFILE_DETAIL = "MY_PROFILE_DETAIL"
export const SALON_DETAIL = "SALON_DETAIL"
export const MY_PROFILE_UPDATE = "MY_PROFILE_UPDATE"
export const MY_PROFILE_SALON_UPDATE = "MY_PROFILE_SALON_UPDATE"
